import React from "react";

export default function MainDashboard() {
    const username = sessionStorage.getItem("user_name");

    return (

        <center>
            {/* <h1 className="welcome-title">Welcome  AP RUSA</h1> */}

            <p className="college-name">
                Welcome  to  {username ?? "-"}
            </p>


        </center>

    );
}
